
export default {
    props: {
        machineModels: {
            type:  Array,
            default:  () => []
        }
    },
}
